import React from 'react'

export const IconDinersCard = () => (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_511:3647)">
      <path
        d="M2.27156 -0.00010667H33.5742C33.7919 -0.000578213 34.0074 0.0419366 34.2086 0.124997C34.4097 0.208058 34.5925 0.330028 34.7463 0.483907C34.9002 0.637785 35.0222 0.820541 35.1053 1.02168C35.1883 1.22283 35.2308 1.43839 35.2304 1.65601V22.3433C35.2308 22.5609 35.1883 22.7765 35.1053 22.9776C35.0222 23.1788 34.9002 23.3615 34.7463 23.5154C34.5925 23.6693 34.4097 23.7913 34.2086 23.8743C34.0074 23.9574 33.7919 23.9999 33.5742 23.9994H2.27156C1.35436 23.9994 0.615787 23.261 0.615787 22.3379V1.65059C0.615331 1.43299 0.657859 1.21745 0.740929 1.01633C0.823999 0.815215 0.945976 0.632487 1.09986 0.47864C1.25374 0.324792 1.43649 0.202853 1.63762 0.119825C1.83875 0.0367971 2.05431 -0.00568552 2.2719 -0.00518359L2.27156 -0.00010667Z"
        fill="#B9DDED"
      />
      <path
        d="M24.779 12.0481C24.779 8.80136 22.069 6.55724 19.0997 6.55817H16.5445C13.5399 6.55713 11.0666 8.80205 11.0666 12.0482C11.0666 15.0177 13.5399 17.4576 16.5445 17.4433H19.0997C22.0688 17.4575 24.7789 15.017 24.7789 12.0481H24.779Z"
        fill="#0079BE"
      />
      <path
        d="M16.5607 7.01807C13.8151 7.01887 11.5904 9.24891 11.5894 12.0011C11.59 14.7529 13.8149 16.9825 16.5607 16.9834C19.3069 16.9825 21.5323 14.753 21.5326 12.0011C21.5323 9.24903 19.3069 7.0191 16.5607 7.01807V7.01807Z"
        fill="white"
      />
      <path
        d="M13.4185 11.9877C13.4212 10.6428 14.2594 9.49599 15.4414 9.04022V14.9344C14.2594 14.479 13.4211 13.3328 13.4185 11.9877V11.9877ZM17.6969 14.9359V9.04045C18.8793 9.49507 19.7189 10.6426 19.7211 11.9881C19.7189 13.3339 18.8793 14.4806 17.6969 14.9362V14.9359Z"
        fill="#0079BE"
      />
    </g>
    <path
      d="M4.61542 1H31.2308V-1H4.61542V1ZM34.2308 4V20H36.2308V4H34.2308ZM31.2308 23H4.61542V25H31.2308V23ZM1.61542 20V4H-0.384583V20H1.61542ZM4.61542 23C2.95856 23 1.61542 21.6569 1.61542 20H-0.384583C-0.384583 22.7614 1.85399 25 4.61542 25V23ZM34.2308 20C34.2308 21.6569 32.8877 23 31.2308 23V25C33.9922 25 36.2308 22.7614 36.2308 20H34.2308ZM31.2308 1C32.8877 1 34.2308 2.34315 34.2308 4H36.2308C36.2308 1.23858 33.9922 -1 31.2308 -1V1ZM4.61542 -1C1.85399 -1 -0.384583 1.23858 -0.384583 4H1.61542C1.61542 2.34315 2.95856 1 4.61542 1V-1Z"
      fill="#CCCCCC"
    />
    <defs>
      <clipPath id="clip0_511:3647">
        <path
          d="M0.615417 4C0.615417 1.79086 2.40628 0 4.61542 0H31.2308C33.4399 0 35.2308 1.79086 35.2308 4V20C35.2308 22.2091 33.4399 24 31.2308 24H4.61542C2.40628 24 0.615417 22.2091 0.615417 20V4Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
